import React from 'react';
import HTMLMessage from '../../HtmlMessage';
import MessageTooltip from '../../MessageTooltip';

interface BotAnswerProps {
  message: {
    i18n: string;
    createdAt: number;
  };
}

const BotAnswer = function ({ message }: BotAnswerProps) {
  return (
    <MessageTooltip message={message}>
      <HTMLMessage message={message} />
    </MessageTooltip>
  );
};

export default BotAnswer;
